import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
	ViewEncapsulation,
} from '@angular/core';
import { FreudMessage, FreudMessageService } from '@freud-ds/web-components';
import { TranslateService } from '@ngx-translate/core';
import {
	INTERACTION_TYPE,
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { IBusySlot } from 'app/interfaces/availability.interface';
import { INewEvent } from 'app/interfaces/event.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import { AvailabilitiesService } from 'app/services/availabilities.service';
import * as moment from 'moment-timezone';
import { MessageService } from 'primeng/api';
import { forkJoin } from 'rxjs';

@Component({
	selector: 'conflict-invite-new-appointment-modal',
	templateUrl: './conflict-invite-new-appointment-modal.component.html',
	providers: [FreudMessageService],
	styleUrls: ['./conflict-invite-new-appointment-modal.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class ConflictInviteNewAppointmentModal implements OnInit, OnChanges {
	@Input() isVisible = false;
	@Input() busySlots: IBusySlot[] = [];
	@Input() appointment: INewEvent;
	@Output() onConfirm: EventEmitter<INewEvent> = new EventEmitter<INewEvent>();
	@Output() onClose: EventEmitter<any> = new EventEmitter<any>();

	busySlotsLength = 0;
	isLoading = false;

	constructor(
		readonly translateService: TranslateService,
		readonly availabilitiesService: AvailabilitiesService,
		readonly messageService: MessageService,
		readonly actionTracker: ActionTrackerService
	) {}

	async ngOnChanges(changes: SimpleChanges) {
		if (changes.busySlots?.currentValue) {
			this.busySlotsLength = this.busySlots.length;
		}
	}

	ngOnInit(): void {
		this.busySlotsLength = this.busySlots.length;
	}

	closeModal(btnClick = false): void {
		if (btnClick) {
			this.actionTracker.eventTracker(
				SCOPE_TYPE.Appointment,
				SUBSCOPE_TYPE.InviteConflict,
				ITEM_TYPE.Cancel,
				INTERACTION_TYPE.Click
			);
		}
		this.isVisible = false;
		this.onClose.emit();
	}

	title(): string {
		return (
			this.busySlotsLength > 1
				? this.translateService.instant(
						'APPOINTMENTS.CONFLICT_INVITE_NEW_APPOINTMENT.MODAL.SUBTITLE_PLURAL'
				  )
				: this.translateService.instant(
						'APPOINTMENTS.CONFLICT_INVITE_NEW_APPOINTMENT.MODAL.SUBTITLE_SINGULAR'
				  )
		).replace('{{quantity}}', this.busySlotsLength);
	}

	footer(): string {
		return this.busySlotsLength > 1
			? this.translateService.instant(
					'APPOINTMENTS.CONFLICT_INVITE_NEW_APPOINTMENT.MODAL.FOOTER_TITLE_PLURAL'
			  )
			: this.translateService.instant(
					'APPOINTMENTS.CONFLICT_INVITE_NEW_APPOINTMENT.MODAL.FOOTER_TITLE_SINGULAR'
			  );
	}

	busySlotTitle(busySlot: IBusySlot): string {
		return busySlot.description;
	}

	busySlotDate(busySlot: IBusySlot): string {
		return `${moment(busySlot.startDate).format(
			'DD/MM/YYYY, HH:mm'
		)} - ${moment(busySlot.endDate).format('HH:mm')}`;
	}

	showLoader(): void {
		this.isLoading = true;
	}

	hideLoader(): void {
		this.isLoading = false;
	}

	confirm() {
		this.actionTracker.eventTracker(
			SCOPE_TYPE.Appointment,
			SUBSCOPE_TYPE.InviteConflict,
			ITEM_TYPE.Submit,
			INTERACTION_TYPE.Click
		);

		this.showLoader();
		forkJoin(
			this.busySlots.map((busySlot) =>
				this.availabilitiesService.removeBusySlot(busySlot.id)
			)
		).subscribe(
			() => {},
			(error) => {
				const message: FreudMessage = {
					severity: 'error',
					summary: this.translateService.instant(
						error.messageI18n
							? error.messageI18n
							: 'ERRORS.HTTP.INTERNALSERVERERROR'
					),
					detail: null,
				};
				this.messageService.add(message);
				this.closeModal();
				this.hideLoader();
			},
			() => {
				this.onConfirm.emit(this.appointment);
				this.closeModal();
				this.hideLoader();
			}
		);
	}
}
